(function initializeTodayMerchGalleryFullscreen(root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.TodayMerchGalleryFullscreen = api;
})(typeof window !== 'undefined' ? window : globalThis, function createTodayMerchGalleryFullscreen() {
  const asString = (value) => String(value ?? '').trim();
  const numericId = (value) => asString(value).match(/(\d+)(?:\D*)$/u)?.[1] || '';
  const sameId = (left, right) => Boolean(numericId(left)) && numericId(left) === numericId(right);

  const isVisibleMediaRecord = (record) => (
    record
    && record.hidden !== true
    && asString(record.ariaHidden).toLowerCase() !== 'true'
    && asString(record.display).toLowerCase() !== 'none'
  );

  const buildVisiblePhotoSwipeDataSource = (records = []) => records
    .filter(isVisibleMediaRecord)
    .map((record) => {
      const source = {
        id: asString(record.mediaIndex),
        mediaId: asString(record.mediaId),
        mediaType: asString(record.mediaType) || 'image',
        sourceElement: record.sourceElement || null,
      };
      if (source.mediaType === 'image') {
        return {
          ...source,
          src: asString(record.src),
          width: Math.max(1, Number(record.width) || 1),
          height: Math.max(1, Number(record.height) || 1),
        };
      }
      return { ...source, html: asString(record.html) };
    });

  const isPresentationOverlayEligible = ({
    hasLogo,
    stateVariantId,
    activeVariantId,
    sourceMediaId,
    activeMediaId,
    overlayHidden,
    hasVisualLayer,
  } = {}) => (
    hasLogo === true
    && sameId(stateVariantId, activeVariantId)
    && sameId(sourceMediaId, activeMediaId)
    && overlayHidden !== true
    && hasVisualLayer === true
  );

  return {
    buildVisiblePhotoSwipeDataSource,
    isPresentationOverlayEligible,
    isVisibleMediaRecord,
    numericId,
  };
});
